<template>
  <div>
    <div class="relative px-6 py-3 pb-6 text-dark-type-4" v-if="!customerNotificationSuccess && !scheduleBookingState">
      <div class>
        <div class="cursor-pointer w-full mb-4 flex justify-end px-4">
        <span @click="close()">
          <svg
              class="absolute"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
          >
            <g fill="none" fill-rule="evenodd">
              <circle cx="12" cy="12" r="12" fill="#FCFCFC" />
              <path
                  d="M16 8l-8 8m0-8l8 8"
                  stroke="#131615"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
              />
            </g>
          </svg>
        </span>
        </div>

        <div class="mx-auto my-4 w-full">
          <img class="mx-auto" src="@/assets/img/bus_traffic_light.svg">
        </div>
        <div class="mx-auto my-4 font-bold text-center text-dark-type-3">
          {{ title || 'This route is currently not available' }}
        </div>
        <div>
          <div v-html="content">
          </div>
        </div>
      </div>
      <button
          @click="openScheduleBooking()"
          class="block w-full h-12 py-4 mt-8 mb-3 font-medium text-sm
        text-center text-black rounded focus:outline-none bg-active">
        Schedule booking
      </button>

      <button
          @click="notifyCustomer()"
          class="block w-full h-12 py-4 font-medium text-sm
        text-center bg-white border border-gray-type-7 rounded text-black focus:outline-none">
        {{loading ? 'Processing' : 'Notify me when available'}}
      </button>
    </div>
    <div v-if="customerNotificationSuccess" class="relative px-6 py-3 pb-6 text-dark-type-4">
      <div class>
        <div class="mx-auto my-4 w-full">
          <img class="mx-auto" src="@/assets/img/bus_traffic_light.svg">
        </div>
        <div class="mx-auto my-4 font-bold text-center text-dark-type-3">
          Notification Set!
        </div>
        <div>
          <p>You will be notified when the selected route <span class="font-medium">({{routeDetails.route.route_code}})</span> is available.</p>
        </div>
      </div>
      <button
          @click="dismiss()"
          class="block w-full h-12 py-4 mt-8 mb-3 font-medium text-sm
        text-center text-black rounded focus:outline-none bg-active">
        Okay
      </button>

    </div>
    <div v-if="scheduleBookingState" class="relative px-6 py-3 pb-6 text-dark-type-4">
      <div class>
        <div class="cursor-pointer w-full mb-4 flex justify-end px-4">
        <span @click="close()">
          <svg
              class="absolute"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
          >
            <g fill="none" fill-rule="evenodd">
              <circle cx="12" cy="12" r="12" fill="#FCFCFC" />
              <path
                  d="M16 8l-8 8m0-8l8 8"
                  stroke="#131615"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
              />
            </g>
          </svg>
        </span>
        </div>
        <div class="mx-auto my-4 w-full">
          <img class="mx-auto" src="@/assets/img/bus_traffic_light.svg">
        </div>
        <div class="mx-auto my-4 font-bold text-center text-dark-type-3">
          Select a new date
        </div>
        <div class="mt-4" v-if="routeDetails.route && routeDetails.route.route_availability_start_date">
          <div class="mx-w-full">
            <div class="relative inline-block w-full date-picker-control">
              <flat-pickr
                  v-model="newDepartureDate"
                  placeholder="Choose new trip date"
                  :config="{ minDate: minDate,  maxDate: routeDetails.route.route_availability_end_date}"
                  class="
                block
                w-full
                h-full
                px-2
                py-2
                border rounded
                pr-8
                text-sm
                font-medium
                leading-tight
                rounded
                appearance-none
                focus:outline-none
                placeholder-label
              "
                  required
              ></flat-pickr>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>
      <button
          @click="scheduleBooking()"
          class="block w-full h-12 py-4 mt-8 mb-3 font-medium text-sm
        text-center text-black rounded focus:outline-none bg-active">
        Proceed
      </button>

    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import axios from "@/services/axios";
import flatPickr from "vue-flatpickr-component";

export default {
  name: "route-notification",
  components: {
    flatPickr
  },
  props: {
    routeDetails: {type: Object},
    title: {type: String},
    content: {type: String}
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    minDate() {
      const startDate = this.routeDetails.route.route_availability_start_date;
      if(this.routeDetails.minDate && !(startDate && this.leftGreaterThanRight(startDate, this.routeDetails.minDate))) {
        return this.routeDetails.minDate;
      } else {
        return this.routeDetails.route.route_availability_start_date;
      }
    }
  },
  data() {
    return {
      customerNotificationSuccess: false,
      loading: false,
      newDepartureDate: '',
      scheduleBookingState: false
    }
  },
  methods: {
    dismiss(){
      this.$emit('customer-notified');
      this.close();
    },
    close() {
      this.$emit('close');
      this.customerNotificationSuccess = false;
      this.scheduleBookingState = false;
      this.newDepartureDate = '';
    },
    notifyCustomer() {
      //TODO: review need for fallback
      // fallback to handle scenario where data may originate from a different process using either route_id or id
      const route_id = this.routeDetails.route.id || this.routeDetails.route.route_id;
      this.loading = true;
      return axios
          .post(`/routes/${route_id}/availability_subscription`, {
            user_id: this.user.id
          })
          .then(() => {
            this.customerNotificationSuccess = true;
          })
          .catch((err) => {
            if(err && err.response?.data && err.response.data.message) {
              this.$toast.error(err.response.data.message);
            } else {
              this.$toast.error('Unable to process request');
            }
          })
          .finally(() => this.loading = false);
    },
    openScheduleBooking() {
      this.scheduleBookingState = true;
    },
    scheduleBooking() {
      if(this.newDepartureDate) {
        this.$emit('schedule-booking', this.newDepartureDate);
        this.$emit('close');
      } else {
        this.$toast.error('Please select a date');
      }
    },
    leftGreaterThanRight(dateOne, dateTwo) {
      return new Date(dateOne).getTime() > new Date(dateTwo).getTime()
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}

.justify-end {
  justify-content: flex-end;
}
</style>